import { useEffect, useState } from 'react';
import { PWAUpdateToast } from './PWAUpdateToast';
import { WhatsNewModal } from './WhatsNewModal';
import { useSession } from '../../providers/AuthProvider';

const STORAGE_KEY = 'lastSeenVersion';

export function ReleaseManager() {
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const { user } = useSession();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Release notes er kun relevante for indloggede brugere — for en
    // førstegangsbesøgende lagde modalen sig OVER login-formularen.
    if (!user) return;
    const currentVersion = __APP_VERSION__;
    const lastSeenVersion = window.localStorage.getItem(STORAGE_KEY);

    if (currentVersion && currentVersion !== lastSeenVersion) {
      setShowWhatsNew(true);
      window.localStorage.setItem(STORAGE_KEY, currentVersion);
    }
  }, [user]);

  useEffect(() => {
    const handler = () => setShowWhatsNew(true);
    window.addEventListener('open-whats-new', handler);
    return () => window.removeEventListener('open-whats-new', handler);
  }, []);

  return (
    <>
      <PWAUpdateToast />
      <WhatsNewModal open={showWhatsNew} onClose={() => setShowWhatsNew(false)} />
    </>
  );
}






